export default class MyVacationsCsv {
  constructor() {

  }

  getMyVacationsCsvHeader() {
    return [ // Warning: Headers must be in English, don't translate them
      'Subject',
      'Start date',
      'End date',
    ];
  }

  getMyVacationsCsv(periods) {
    return periods.map(this._periodToRow, this);
  }

  _periodToRow(period) {
    return [
      this._getEventName(period),
      this._getEventDate(period.startDate),
      this._getEventDate(period.endDate),
    ];
  }

  _getEventName(period) {
    const type=period.absenceType || period.vacationType;
    const category=period.category;

    if (type===category) {
      return `${category}`;
    }

    return `${type}-${category}`;
  }

  _getEventDate(date) {
    const parts=date.split('-');
    const year=parts[0];
    const month=parts[1];
    const day=parts[2];
    return `${month}/${day}/${year}`;
  }
}



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/myVacations.csv.js